import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaInstagram, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const momentos = [
  {
    src: require('../../../static/images/momentos/concierto-fin-2021.webp'),
    alt: 'Concierto de Fin de Año 2021',
    titulo: 'Concierto de Fin de Año',
    año: '2021',
    href: 'https://www.facebook.com/media/set/?set=a.6703094446427954&type=3',
  },
  {
    src: require('../../../static/images/momentos/concierto-frank-di-paulino.webp'),
    alt: 'Concierto Frank Di & Paulino Monroy',
    titulo: 'Frank Di & Paulino Monroy',
    año: '2017',
    href: 'https://www.facebook.com/media/set/?set=a.1761222913948490&type=3',
  },
  {
    src: require('../../../static/images/momentos/momento-1.webp'),
    alt: 'Concierto de Fin de Año 2025',
    titulo: 'Concierto de Fin de Año',
    año: '2025',
    href: null,
  },
  {
    src: require('../../../static/images/momentos/momento-2.webp'),
    alt: 'Concierto de Fin de Año 2025',
    titulo: 'Concierto de Fin de Año',
    año: '2025',
    href: null,
  },
  {
    src: require('../../../static/images/momentos/momento-3.webp'),
    alt: 'Concierto de Fin de Año 2025',
    titulo: 'Concierto de Fin de Año',
    año: '2025',
    href: null,
  },
  {
    src: require('../../../static/images/momentos/momento-4.webp'),
    alt: 'Concierto de Fin de Año 2025',
    titulo: 'Concierto de Fin de Año',
    año: '2025',
    href: null,
  },
];

export default function MomentosCarousel() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + momentos.length) % momentos.length);
  const next = () => setCurrent((c) => (c + 1) % momentos.length);

  const momento = momentos[current];

  return (
    <section id="momentos" className="bg-white py-24 px-4">
      <div className="max-w-6xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16"
        >
          <div>
            <p className="text-gray-400 uppercase tracking-[0.3em] text-sm mb-4">
              Nuestra historia viva
            </p>
            <h2 className="text-5xl font-black text-black">Momentos Larghetto</h2>
          </div>
          <a
            href="https://www.instagram.com/larghetto_academia"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full text-white font-bold text-sm tracking-wide transition-all hover:scale-105 hover:shadow-xl flex-shrink-0"
            style={{
              background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
            }}
          >
            <FaInstagram size={18} />
            Síguenos en Instagram
          </a>
        </motion.div>

        {/* Carrusel */}
        <div className="relative rounded-3xl overflow-hidden mb-10 shadow-lg" style={{ height: '480px' }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 block"
            >
              {momento.href ? (
                <a href={momento.href} target="_blank" rel="noreferrer" className="absolute inset-0 block">
                  <img src={momento.src} alt={momento.alt} className="w-full h-full object-cover" />
                </a>
              ) : (
                <img src={momento.src} alt={momento.alt} className="w-full h-full object-cover" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-8 left-8">
                <p className="text-white/70 text-sm uppercase tracking-widest mb-1">
                  {momento.año}
                </p>
                {momento.titulo && (
                  <h3 className="text-white text-2xl font-black">{momento.titulo}</h3>
                )}
              </div>
            </motion.div>
          </AnimatePresence>

          <button
            onClick={prev}
            aria-label="Imagen anterior"
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 transition-all z-10"
          >
            <FaChevronLeft size={16} />
          </button>

          <button
            onClick={next}
            aria-label="Imagen siguiente"
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 transition-all z-10"
          >
            <FaChevronRight size={16} />
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
            {momentos.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                aria-label={`Ir a imagen ${i + 1}`}
                className={`h-2 rounded-full transition-all ${
                  i === current ? 'bg-white w-6' : 'bg-white/40 w-2'
                }`}
              />
            ))}
          </div>
        </div>


      </div>

    </section>
  );
}
